// clinica-front/src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#0066cc',      // Azul Eléctrico Clínico (Alta visibilidad)
            light: '#e3f2fd',
            dark: '#004499',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#4f46e5',      // Índigo Figma Pro para elementos de acento
        },
        success: {
            main: '#10b981',      // Verde Esmeralda (Estilo Clinic Cloud)
            light: '#ecfdf5',
            dark: '#047857',
        },
        warning: {
            main: '#f59e0b',      // Naranja Ámbar de atención
            light: '#fffbeb',
            dark: '#b45309',
        },
        error: {
            main: '#ef4444',      // Rojo Coral para alertas y cancelaciones
            light: '#fef2f2',
            dark: '#b91c1c',
        },
        background: {
            default: '#f8fafc',   // Gris pizarra ultra-limpio (hace resaltar el color)
            paper: '#ffffff',     // Blanco puro para las tarjetas
        },
        text: {
            primary: '#0f172a',   // Azul marino muy oscuro (máximo contraste y elegancia)
            secondary: '#475569', // Gris Slate para textos secundarios
        },
    },
    typography: {
        fontFamily: '"SF Pro Display", "-apple-system", "BlinkMacSystemFont", "Inter", "Segoe UI", sans-serif',
        h4: {
            fontWeight: 800,      // Texto más rotundo y corporativo
            letterSpacing: '-0.03em',
            color: '#0f172a',
        },
        h5: {
            fontWeight: 700,
            letterSpacing: '-0.02em',
        },
        h6: {
            fontWeight: 700,
            letterSpacing: '-0.01em',
        },
        body1: {
            fontSize: '0.95rem',
            letterSpacing: '-0.005em',
            color: '#334155',
        },
        button: {
            fontWeight: 600,
            textTransform: 'none',
        },
    },
    shape: {
        borderRadius: 14, // Bordes sutilmente más suavizados, máxima tendencia UI
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    padding: '10px 20px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                    fontWeight: 600,
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        transform: 'translateY(-1px)', // Efecto interactivo premium al pasar el ratón
                        boxShadow: '0 4px 12px rgba(0, 64, 227, 0.15)',
                    },
                },
                containedPrimary: {
                    background: 'linear-gradient(135deg, #0066cc 0%, #0052a3 100%)', // Sutil degradado Pro
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '24px',
                    boxShadow: '0 10px 30px -10px rgba(0, 0, 0, 0.03), 0 1px 3px rgba(0, 0, 0, 0.02)',
                    border: '1px solid #e2e8f0', // Contorno limpio y nítido
                    backgroundColor: '#ffffff',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: '0 10px 30px -10px rgba(0, 0, 0, 0.03), 0 1px 3px rgba(0, 0, 0, 0.02)',
                    border: '1px solid #e2e8f0',
                },
                elevation0: {
                    boxShadow: 'none',
                    border: 'none',
                }
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: '1px solid #f1f5f9',
                    padding: '16px 20px',
                },
                head: {
                    color: '#475569',
                    fontWeight: 700,
                    backgroundColor: '#f1f5f9', // Cabeceras de tabla con más presencia y contraste
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    transition: 'all 0.2s',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#cbd5e1',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#94a3b8',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '2px',
                        borderColor: '#0066cc',
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    fontWeight: 600,
                },
            },
        },
    },
});

export default theme;